import {Skeleton} from "../../../api/types";
import {useEffect, useState} from "react";
import {Modal} from "../../Modal";
import {agent} from "../../../api/agent";


interface Props {
    skeleton: Skeleton;
    open: boolean;
    onClose?: () => void;
}

interface AssetModalProps {
    id: string;
    assets: string[];
    folder: string;
}

export default function AssetsModal({skeleton, open, onClose}: Props) {
    const [assetModal, setAssetModal] = useState<AssetModalProps | null>(null);

    const getFolders = () => {
        if (!assetModal) return [];
        const folders: string[] = [];
        if (assetModal.folder) {
            folders.push('..');
        }

        for (const asset of assetModal.assets) {
            if (!asset.includes(assetModal.folder)) {
                continue;
            }
            let localFile = asset.substring(!assetModal.folder ? 0 : (assetModal.folder + (asset.includes('/') ? '/' : '')).length);
            const parts = localFile.split('/');

            if (parts.length > 1) {
                const folder = parts[0];
                if (!folders.includes(folder)) {
                    folders.push(folder);
                }
            }
        }
        return folders;
    }

    const getFiles = () => {
        if (!assetModal) return [];
        const files: string[] = [];
        for (const asset of assetModal.assets) {
            if (!asset.includes(assetModal.folder)) {
                continue;
            }
            let localFile = asset.substring(!assetModal.folder ? 0 : (assetModal.folder + (asset.includes('/') ? '/' : '')).length);
            if (!localFile.includes('/')) {
                files.push(localFile);
            }
        }
        return files;
    }

    useEffect(() => {

        if (!open) {
            setAssetModal(null);
            return;
        }

        setAssetModal({
            id: skeleton.id,
            assets: skeleton.assets || [],
            folder: ''
        });

    }, [open]);

    return <Modal open={!!assetModal} onClose={() => {
        if (onClose)
            onClose();
    }}>
        {assetModal && (<div>
            <h1>Assets for Job {assetModal?.id}</h1>
            <p>/{assetModal?.folder}</p>
            <ul>
                {getFolders().map((folder) => (
                    <li key={folder} style={{cursor: 'pointer'}} onClick={() => {
                        if (folder === '..') {
                            setAssetModal({
                                ...assetModal,
                                folder: assetModal.folder.split('/').slice(0, -1).join('/')
                            });
                        } else {
                            setAssetModal({
                                ...assetModal,
                                folder: assetModal.folder + (assetModal.folder ? '/' : '') + folder
                            });
                        }
                    }}><i className="fa-solid fa-folder-open"></i> - {folder}
                        {folder !== '..' && (
                            <div style={{display: 'inline-block', marginLeft: '1rem'}} onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();

                                agent.requestAsset(assetModal.folder + (assetModal.folder ? '/' : '') + folder, assetModal.id).then((response) => {
                                    //const base64 = response.base64;
                                    //const blob = new Blob([Uint8Array.from(atob(base64), c => c.charCodeAt(0))], {type: 'application/octet-stream'});
                                    //const url = URL.createObjectURL(blob);
                                    const url = 'https://api-ci.zenzon.net/download?token=' + response.token;
                                    const a = document.createElement('a');
                                    a.href = url;
                                    a.target = '_blank';
                                    //a.download = response.filename;
                                    document.body.appendChild(a);
                                    a.click();
                                });
                            }}><i className="fa-solid fa-download"></i></div>
                        )}
                    </li>
                ))}
                {getFiles().map((file) => (
                    <li key={file} style={{cursor: 'pointer'}} onClick={() => {

                    }}><i className="fa-solid fa-file"></i> - {file}
                        <div style={{display: 'inline-block', marginLeft: '1rem'}} onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            agent.requestAsset(assetModal.folder + (assetModal.folder ? '/' : '') + file, assetModal.id).then((response) => {
                                //const base64 = response.base64;
                                //const blob = new Blob([Uint8Array.from(atob(base64), c => c.charCodeAt(0))], {type: 'application/octet-stream'});
                                //const url = URL.createObjectURL(blob);
                                const url = 'https://api-ci.zenzon.net/download?token=' + response.token;
                                const a = document.createElement('a');
                                a.href = url;
                                a.target = '_blank';
                                //a.download = response.filename;
                                document.body.appendChild(a);
                                a.click();
                            });
                        }}><i className="fa-solid fa-download"></i></div>
                    </li>
                ))}
            </ul>
        </div>)}
    </Modal>;


}